export const book = Object.freeze({
    login:       '/login',
    signUp:      '/sign-up',
    feed:        '/feed',
    profile:     '/profile',
    newPassword: '/new-password',
});
